/**
 * 按钮级权限控制指令
 */
export default {
  install(Vue) {
    Vue.directive('permission', {
      inserted(el, binding) {
        const permissionCode = binding.value;
        if (!permissionCode) {
          return;
        }
        
        // 检查是否是超级管理员或admin账号
        const username = sessionStorage.getItem('username');
        if (username === 'admin') {
          // admin账号拥有所有权限
          return;
        }
        
        // 检查是否有超级管理员角色
        const roles = sessionStorage.getItem('roles');
        if (roles && roles.includes('超级管理员')) {
          // 超级管理员角色拥有所有权限
          return;
        }
        
        // 从sessionStorage获取按钮权限列表
        const buttonPermissionsStr = sessionStorage.getItem('buttonPermissions');
        if (!buttonPermissionsStr) {
          // 用隐藏代替删除，避免 Vue 虚拟 DOM 引用失效导致 insertBefore 报错
          el.style.display = 'none';
          return;
        }

        try {
          const buttonPermissions = JSON.parse(buttonPermissionsStr);
          if (!buttonPermissions.includes(permissionCode)) {
            el.style.display = 'none';
          }
        } catch (error) {
          console.error('解析按钮权限数据失败:', error);
          el.style.display = 'none';
        }
      }
    });
  }
};
